/** Wyrd Grove brand — allineato a Canva (#164c32, IM Fell English SC, Open Sans) */
export const brand = {
  logo: '/logo.svg',
  avatar: '/avatar.png',
  siteName: 'Wyrd Grove',
  green: '#164c32',
}
